import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  logError(message: string, stack: string) {
    // Send errors to be saved here
    // tracking coming soon™ ?
    console.log('Logging Message: ' + message); // console log for now
    console.log('Logging Stack: ' + stack); // console log for now
  }
}
